import React, { useState, useEffect } from 'react';
import {
  Box,
  Divider,
  Typography,
  Grid,
  Stack,
  IconButton,
  Button,
  FormControl,
  Avatar,
  Tooltip,
} from '@mui/material';
import { BsFillTrashFill, BsPlus } from 'react-icons/bs';
import { ComboBox } from 'components';
import ApiServices from 'services';

const AddMainSer = ({
  clientCompanyId,
  serParentListActive = [],
  mainServiceList = [],
  reloadData,
  onCloseModal,
}) => {
  const [serviceSelected, setServiceSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAdd = async (serviceList) => {
    if (loading || serviceList?.length <= 0) return;
    const serviceIdList = serviceList?.map((el) => el.id);
    setLoading(true);
    try {
      const res = await ApiServices.updateUpdateServiceCC(clientCompanyId, {
        idsToAdd: serviceIdList,
      });
      if (res.status === 200) {
        reloadData();
        window.UIMessage?.success('Cập nhật thành công');
        onCloseModal();
      }
    } catch (error) {
      window.UIMessage?.error('Cập nhật thất bại !!!');
    } finally {
      setLoading(false);
    }
  };

  const onHandleChangeFn = (event, newValue) => {
    setServiceSelected(newValue);
  };

  const mainServiceListFilter = mainServiceList?.filter(
    (el) => !serParentListActive?.includes(el?.id),
  );

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 10,
        padding: 15,
      }}
    >
      <ComboBox
        style={{
          flex: 1,
        }}
        multiple
        disableCloseOnSelect
        options={mainServiceListFilter}
        label="Dịch vụ"
        keyField="name"
        value={serviceSelected}
        onChange={(event, newValue) => onHandleChangeFn(event, newValue)}
      />
      <Box
        style={{
          marginTop: 50,
          marginLeft: 'auto',
        }}
      >
        <Button
          variant="contained"
          size="small"
          startIcon={<BsPlus />}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            marginLeft: '18px',
            color: '#FFFFFF',
            backgroundColor: '#21409A',
            '.MuiButton-endIcon': {
              marginLeft: '0px',
            },
            padding: '5px 15px 5px 10px',
          }}
          onClick={() => handleAdd(serviceSelected)}
          disabled={!serviceSelected?.length > 0}
        >
          Thêm
        </Button>
      </Box>
    </Box>
  );
};

export { AddMainSer };
